<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{ name: 'scgl_scrw_scdd' }" style="position: absolute;top: 12px;left: 200px;"><el-button size="mini">回到生产订单</el-button></router-link>

		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 35%;">
					<el-form-item label="MRP编号"><el-input placeholder="自动生成" :disabled="true"></el-input></el-form-item>
					<el-form-item label="完成时间">
						<el-date-picker
						      v-model="value1"
						      type="date"
						      placeholder="选择日期">
						    </el-date-picker>
					</el-form-item>
				</div>
				<div style="width: 66%;">
					<el-form-item label="关联生产">
						<el-button type="primary" size='mini'>MK100{{data}}</el-button>
					</el-form-item>
					<el-form-item label="备注"><el-input v-model="form.desc" style="width: 95%;"></el-input></el-form-item>
				</div>
			</div>
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;">
				<div class="m-4 d-flex">
					<div>生产信息</div>
				</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="tableDatac" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }">
						<el-table-column prop="id" label="序号" width="50" align="center"></el-table-column>
						<el-table-column prop="id" label="成品编码" width="80" align="center"></el-table-column>
						<el-table-column prop="name" label="成品名称/规格" width="350"></el-table-column>
						<el-table-column prop="noid" label="成品编码/sku" width="350"></el-table-column>
						<el-table-column prop="dw" label="单位" align="center"></el-table-column>
						<el-table-column prop="num" label="数量" align="center"></el-table-column>
					</el-table>
				</div>
			</div>
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;" class="mt-3">
				<div class="m-4 d-flex">
					<div>原料信息</div>
				</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="tableDatac" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }">
						<el-table-column prop="id" label="序号" width="50" align="center"></el-table-column>
						<el-table-column prop="id" label="原料编码" width="80" align="center"></el-table-column>
						<el-table-column prop="name" label="原料名称/规格" width="280"></el-table-column>
						<el-table-column prop="noid" label="原料编码/sku" width="280"></el-table-column>
						<el-table-column prop="dw" label="单位" align="center"></el-table-column>
						<el-table-column prop="num" label="仓存数量" align="center"></el-table-column>
						<el-table-column prop="num" label="需求数量" align="center"></el-table-column>
						<el-table-column prop="num" label="采购数量" align="center"></el-table-column>
						<el-table-column prop="num" label="损耗率" align="center"></el-table-column>
					</el-table>
				</div>
			</div>
		</el-form>
		<el-button type="primary" style="position: fixed;bottom: 50px;right: 50px;" @click="submit">提交</el-button>
	</div>
</template>

<script>
import tinymce from '@/components/common/tinymce.vue'; // 引入 富文本 组件
import skuCard from '@/components/shop/create/sku/sku-card.vue'; // 引入 sku规格卡片 组件
import skuTable from '@/components/shop/create/sku-table.vue'; // 引入 多规格 规格属性列表 组件
import { mapState, mapMutations } from 'vuex'; // 引入 全局 公共数据
export default {
	inject: ['app', 'layout'],
	components: {
		skuCard,
		skuTable,
		tinymce
	},
	data() {
		return {
			data:0,
			tableDatac: [
				{
					id: 1,
					name: '文具',
					noid: 'P156',
					gemc: '无印良品',
					gebm: 'T15612',
					pch: 748,
					dw: '盒',
					num: 41569,
					dj: 15,
					je: 41515,
					day: 90,
					time: '2022-08-24'
				}
			],
			tableDatab: [],
			radio: 1,
			id: 0,
			cates: [],
			express: [],
			coupon: [],
			form: {
				title: '', //商品名称
				category_id: '', //商品分类
				cover: '', //商品封面
				desc: '', //商品描述
				unit: '', //商品单位
				stock: '', //总库存
				min_stock: '', //库存预警
				ischeck: 0, //是否审核 0待处理 1通过 2拒绝
				status: 0, //是否上架 0仓库 1上架
				stock_display: 0, //库存显示 0隐藏 1禁用
				express_id: '', //运费模板
				min_price: '', //最低销售价
				min_oprice: '', //最低原价
				commission: '', // 佣金
				mamager_id: '', // 商家id
				srcs: '',
				coupon_id: '' // 优惠券
			},
			value2: '',
			options2: [
				{
					value: '产品储存',
					label: '产品储存'
				},
				{
					value: '贵重物品',
					label: '贵重物品'
				},
				{
					value: '易碎品',
					label: '易碎品'
				}
			],
			options: [
				{
					value: '广东',
					label: '广东'
				},
				{
					value: '上海',
					label: '上海'
				},
				{
					value: '深圳',
					label: '深圳'
				}
			],
			value: [],
			value1: '2022-08-24',
			optionss: [
				{
					value: '产品储存',
					label: '产品储存'
				},
				{
					value: '贵重物品',
					label: '贵重物品'
				},
				{
					value: '易碎品',
					label: '易碎品'
				}
			],
			values: [],
			optionssa: [
				{
					value: '选项1',
					label: '黄金糕'
				},
				{
					value: '选项2',
					label: '双皮奶'
				},
				{
					value: '选项3',
					label: '蚵仔煎'
				},
				{
					value: '选项4',
					label: '龙须面'
				},
				{
					value: '选项5',
					label: '北京烤鸭'
				}
			],
			valuesa: '',
			color: null,
			updateList: [
				{
					name: '销售价',
					key: 'pprice'
				},
				{
					name: '市场价',
					key: 'oprice'
				},
				{
					name: '成本价',
					key: 'cprice'
				},
				{
					name: '库存',
					key: 'stock'
				},
				{
					name: '体积',
					key: 'volume'
				},
				{
					name: '重量',
					key: 'weight'
				}
			],
			updateAllStatus: false,
			UpdateAllPlaceholder: '',
			UpdateAllValue: '',
			content: ''
		};
	},
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user,
			navBar: state => state.menu.navBar,
			skus_type: state => state.goods_create.skus_type,
			sku_card: state => state.goods_create.sku_card
		}),
		// 规格卡片总数
		skuCardTotal() {
			return this.sku_card.length;
		}
	},
	// 过滤器 商品无限级分类
	filters: {
		tree(item) {
			if (item.level == 0) {
				return item.name;
			}
			let str = '';
			for (let i = 0; i < item.level; i++) {
				str += i == 0 ? '|--' : '--';
			}
			return str + ' ' + item.name;
		}
	},
	// 生命周期
	created() {
		this.getdata()
		this.id = this.$route.params.id; //拿到当前商品id
		if (this.id) {
			this.axios
				.get('/admin/goods/read/' + this.id, {
					token: true
				})
				.then(res => {
					let data = res.data.data;
					this.form = data;
					this.content = data.content;
					this.vModel(
						'sku_card',
						data.goodsSkusCard.map(item => {
							item.list = item.goodsSkusCardValue;
							item.list.map(v => {
								v.text = item.type === 0 ? v.value : defaultVal[0];
								v.color = item.type === 1 ? v.value : defaultVal[1];
								v.image = item.type === 2 ? v.value : defaultVal[2];
								return v;
							});
							return item;
						})
					);
					// 初始化商品表格
					this.vModel('skus_type', data.sku_type);
					(this.sku_value = data.sku_value
						? data.sku_value
						: {
								oprice: 0, // 市场价格
								pprice: 0, // 销售价格
								cprice: 0, // 成本价格
								weight: 0, // 重量
								volume: 0 // 体积
						  }),
						this.$nextTick(() => {
							if (this.$refs.table) {
								this.$refs.table.list = data.goodsSkus;
							}
						});
				})
				.catch(err => {});
		}

		// 获取商品分类api
		this.axios
			.get('/admin/goods/create', {
				token: true
			})
			.then(res => {
				let data = res.data.data;
				console.log(data);
				this.cates = data.cates;
				this.express = data.express.list;
				this.coupon = data.coupon;
			});

		// 获取之前的商品详情
		let defaultVal = ['属性值', '#FFFFFF', '/favicon.ico'];
	},
	methods: {
		getdata(){
			this.data = this.$route.query.data
		},
		onClick(e, editor) {},
		handleChange(value) {
			console.log(value);
		},
		chooseImage() {
			this.app.chooseImage(res => {
				this.form.cover = res[0].url;
			}, 1);
		},
		...mapMutations(['vModelState', 'addSkuCard', 'vModelGoodsAttrs']),
		addSkuCardEvent() {
			this.layout.showLoading();
			this.axios
				.post(
					'/admin/goods_skus_card',
					{
						//添加规格 api
						goods_id: this.id,
						name: '规格名称',
						order: 50,
						type: 0
					},
					{ token: true }
				)
				.then(res => {
					let data = res.data.data;
					data.list = [];
					this.addSkuCard(data);
					this.layout.hideLoading();
				})
				.catch(err => {
					this.layout.hideLoading();
				});
		},
		vModel(key, value) {
			this.vModelState({ key, value });
		},
		openUpdateAllStatus(item) {
			this.updateAllStatus = item.key;
			this.UpdateAllPlaceholder = item.name;
		},
		closeUpdateAllStatus() {
			this.updateAllStatus = false;
			this.UpdateAllValue = '';
		},
		UpdateAllSubmit() {
			this.$refs.table.list.forEach(item => {
				item[this.updateAllStatus] = this.UpdateAllValue;
			});
			this.closeUpdateAllStatus();
		},
		onSubmit() {},

		//提交
		submit() {
			if (this.radio == 2) {
				this.form.srcs = 'http://qfy0752.oss-cn-guangzhou.aliyuncs.com/public/62412b9a9e8c3.png';
			} else if (this.radio == 3) {
				this.form.srcs = 'http://qfy0752.oss-cn-guangzhou.aliyuncs.com/public/62412b9a9c02e.png';
			} else if (this.radio == 4) {
				this.form.srcs = 'http://qfy0752.oss-cn-guangzhou.aliyuncs.com/public/62412b9a9d47f.png';
			} else if (this.radio == 5) {
				this.form.srcs = 'http://qfy0752.oss-cn-guangzhou.aliyuncs.com/public/62412b9a9fbd6.png';
			} else {
				this.form.srcs = '';
			}
			this.layout.showLoading();
			let url = this.id ? '/admin/goods/' + this.id : '/admin/goods';
			this.form.mamager_id = this.form.mamager_id ? this.form.mamager_id : this.user.id;
			this.axios
				.post(url, this.form, {
					token: true
				})
				.then(res => {
					this.$message({
						type: 'success',
						message: this.id ? '修改成功' : '发布成功' //如果this.id存在,就是修改成功,否则就是发布成功
					});
					this.$router.push({
						name: 'cggl_ddcl_cgdd'
					});
					this.layout.hideLoading();
				})
				.catch(err => {
					this.layout.hideLoading();
				});
		}
	}
};
</script>

<style>
.goods_create .el-form-item {
	margin-bottom: 15px;
}
.pt-a {
	padding-top: 20px;
}
</style>
